import { FORTEM_URIS } from '@/constants/uris'
import { MonitoringDashboardPage } from '@/pages/monitoring/_dashboard/page'
import { CustomJobPage } from '@/pages/monitoring/custom-jobs/page'
import { MonitoringLayout } from '@/pages/monitoring/layout'
import { LogsPage } from '@/pages/monitoring/logs/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const monitoringRoutes = [
  {
    path: FORTEM_URIS.MONITORING.__INDEX__,
    element: <MonitoringLayout />,
    handle: {
      title: 'Monitoring',
    },
    children: [
      {
        index: true,
        element: <MonitoringDashboardPage />,
        handle: {
          title: 'All Tasks',
        },
      },
      {
        path: FORTEM_URIS.MONITORING.CUSTOM_JOBS,
        element: <CustomJobPage />,
        handle: {
          title: 'Custom Jobs',
        },
      },
      {
        path: FORTEM_URIS.MONITORING.LOGS,
        element: <LogsPage />,
        handle: {
          title: 'Logs',
        },
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
